import { toJSON } from '@rehaje/shared'

import { UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { SchemaTypedSchemaSpecific, TypedSchema } from '../../types'

export class SchemaTypedSchemaDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaTypedSchemaSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaTypedSchemaSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(
    target?: any,
    schema?: SchemaTypedSchemaSpecific
  ): TypedSchema {
    return { ...schema, type: 'Schema.TypedSchema', value: target }
  }

  override inferOnlySchema(schema: TypedSchema) {
    return schema
  }

  override inferTypeScript(schema: SchemaTypedSchemaSpecific): string {
    return JSON.stringify(toJSON(schema.value))
  }

  override prune(target: any): any {
    return target
  }

  override transform(target: any) {
    return target
  }

  override validate(target: any, schema: SchemaTypedSchemaSpecific): void {
    this.validateMetadata(target, schema, (target) => {
      return target?.type === 'Schema.TypedSchema'
    })
  }
}
